import { cn } from "@cca/components";
import { useEffect, useState } from "react";

const ticks = [...new Array(4)].map((_, i) => i);

export type LoaderProps = React.HTMLAttributes<HTMLSpanElement> & {
  fullScreen?: boolean;
};

export const Loader = ({ className, fullScreen, ...props }: LoaderProps) => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(
      () => setTick((prevTick) => (prevTick + 1) % 4),
      200,
    );

    return () => clearInterval(intervalId);
  }, []);

  const children = (
    <span className={cn("flex h-2 items-center gap-2", className)} {...props}>
      {ticks.map((item) => (
        <span
          className={cn(
            "aspect-square h-full rounded-full bg-gray-200 duration-200",
            { "bg-blue-500": item == tick },
          )}
          key={item}
        />
      ))}
    </span>
  );

  if (!fullScreen) {
    return children;
  }

  return (
    <div className="flex h-screen w-full flex-1 items-center justify-center">
      {children}
    </div>
  );
};
